import { trans } from "@mongez/localization";
import { FinancialInfoReportsTab } from "./FinancialInfoReportsTab";
import { FinancialInfoStatementsTab } from "./FinancialInfoStatementsTab";
import { QuarterlyReportsTab } from "./QuarterlyReportsTab";
import { Tabs } from "./tabs";

export function FinancialInformationTabs() {
  return (
    <div className="py-12">
      <Tabs
        tabs={[
          {
            label: trans("financialAnnouncements"),
            value: "financialAnnouncements",
            component: () => <QuarterlyReportsTab />,
          },
          {
            label: trans("financialStatements"),
            value: "statements",
            component: () => <FinancialInfoStatementsTab />,
          },
          {
            label: trans("financialReports"),
            value: "reports",
            component: () => <FinancialInfoReportsTab />,
          },
        ]}
      />
    </div>
  );
}
